import { useState } from 'react';
import Fetch from '@/services/fetch/Fetch';
import { envToBaseUrl } from '@/utils/env';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { z } from 'zod';
import CreateUserForm from './CreateUserForm';
import { UserutilsHook, formSchema, ROLES, NONE_VALUE } from './userUtilsHook';

export function RequestUserAccess() {
  const [loading, setLoading] = useState(false);
  const [submittedSuccess, setSubmittedSuccess] = useState(false);
  const { markets, form, env, role } = UserutilsHook();

  const requestCreateUserMutation = useMutation({
    mutationFn: async (form: z.infer<typeof formSchema>) => {
      setLoading(true);

      const dataToSend = {
        ...form,
        marketRestrictions: form.marketRestrictions.includes(NONE_VALUE)
          ? []
          : form.marketRestrictions,
      };

      await Fetch.json(`${envToBaseUrl(env)}/userAccess/request-user-access`, {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });
    },
    onSuccess: async () => {
      setSubmittedSuccess(true);
      toast.success('Successfully requested user access');
    },
    onError: (error) => {
      toast.error(error.message);
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  function onSubmit(data: z.infer<typeof formSchema>) {
    requestCreateUserMutation.mutate(data);
  }

  const filterRoles =
    role === 'admin' ? ROLES : ROLES.filter((role) => role.value !== 'admin');

  return (
    <>
      {submittedSuccess ? (
        <>
          <h2 className='mt-4 font-bold'>
            Successfully submitted user request
          </h2>
          <p>We will try to approve your request within 24 hour</p>
        </>
      ) : (
        <CreateUserForm
          form={form}
          onSubmit={form.handleSubmit(onSubmit)}
          roles={filterRoles}
          markets={markets}
          loading={loading}
          title='Request user access'
        />
      )}
    </>
  );
}
